import { useMutation } from '@tanstack/react-query';

import { fetchJson } from '../fetch';

type Payload = {
  emailAddress: string;
};

export const useResendVerificationEmail = () => {
  return useMutation({
    mutationFn: (body: Payload) => {
      return fetchJson('/registration/resend-verification-email', { method: 'POST', body });
    },
  });
};
